import { Box, Center, Group, Text, useMantineTheme } from '@mantine/core';
import { IconPhoneSpark, IconUser } from '@tabler/icons-react';

export type TranscriptMessage = {
  content: string;
  speaker: 'AI' | 'User';
  index: number;
};

interface ConversationMessageProps {
  message: TranscriptMessage;
}

export const ConversationMessage = ({ message }: ConversationMessageProps) => {
  const theme = useMantineTheme();
  const isAI = message.speaker === 'AI';

  return (
    <Center>
      <Group
        w="70%"
        gap="sm"
        justify={isAI ? 'flex-start' : 'flex-end'}
        align="center"
        wrap="nowrap"
      >
        {isAI && <IconPhoneSpark size={18} color={theme.colors.purple[6]} stroke={1.5} />}

        <Box
          maw="70%"
          px="md"
          py="xs"
          bd={`1px solid ${isAI ? 'purple.2' : 'gray.3'}`}
          style={{
            borderRadius: 12,
            backgroundColor: isAI ? theme.colors.purple[1] : theme.colors.gray[2],
          }}
        >
          <Text
            c={isAI ? 'purple.8' : 'gray.8'}
            size="sm"
            style={{
              color: isAI ? 'purple.8' : 'gray.8',
              lineHeight: 1.4,
            }}
          >
            {message.content}
          </Text>
        </Box>

        {!isAI && <IconUser size={18} color={theme.colors.gray[6]} stroke={1.5} />}
      </Group>
    </Center>
  );
};
